import React from "react";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

function LoadBackdrop({ style = '' }) {
    return (
        <div>
            <Backdrop
                sx={{ background : '#ffffff', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={true}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default LoadBackdrop;
